<template>
  <!-- Estado vacío / pantalla inicial genérica y reutilizable.
       Usa las clases globales .epc-empty* (epc-empty-state.scss). -->
  <div class="epc-empty">
    <div v-if="loading" class="epc-empty__loading">
      <b-icon pack="fas" icon="spinner" custom-class="fa-spin" size="is-large" />
    </div>

    <template v-else>
      <div v-if="icon" class="epc-empty__icon">
        <b-icon pack="fas" :icon="icon" size="is-large" />
      </div>

      <h3 v-if="title" class="epc-empty__title">{{ title }}</h3>
      <p v-if="subtitle" class="epc-empty__sub">{{ subtitle }}</p>

      <div v-if="actions.length || $slots.actions" class="epc-empty__actions">
        <!-- Botones por defecto desde `actions`; o contenido propio vía slot. -->
        <slot name="actions">
          <b-button
            v-for="a in actions"
            :key="a.name"
            :type="a.type || 'is-primary'"
            size="is-small"
            icon-pack="fas"
            :icon-left="a.icon"
            @click="$emit('action', a.name)"
          >{{ a.label }}</b-button>
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'EmptyContent',

    props: {
      // Muestra un spinner en lugar del contenido.
      loading: { type: Boolean, default: false },
      // Icono FontAwesome del círculo superior (vacío = sin icono).
      icon: { type: String, default: '' },
      title: { type: String, default: '' },
      subtitle: { type: String, default: '' },
      // Acciones (botones): [{ name, label, icon, type }]. Al pulsar emite 'action' con `name`.
      // Alternativamente, usar el slot #actions para contenido propio.
      actions: { type: Array, default: () => [] },
    },
  };
</script>
